import { Grid2 } from "@mui/material";
import MyRewardsWidget from "../../../features/my-rewards-widget/MyRewardsWidget";

const MyRewardsGrid = () => (
  <Grid2 container spacing={2}>
    <Grid2 size={{ xs: 12 }} display="flex" justifyContent={"center"}>
      <MyRewardsWidget />
    </Grid2>
  </Grid2>
);

export default MyRewardsGrid;
